import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { UserAuthProvider, useUserAuth } from "./context/UserAuthContext";

// Public Pages
import UserLoginPage from "./pages/UserLoginPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminUnits from "./pages/admin/AdminUnits";
import AdminMapEditor from "./pages/admin/AdminMapEditor";
import AdminSync from "./pages/admin/AdminSync";

// Admin Protected Route
const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// User Protected Route
const UserRoute = ({ children }) => {
  const { isAuthenticated, loading } = useUserAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* User Login */}
      <Route path="/login" element={<UserLoginPage />} />
      
      {/* Protected Public Routes */}
      <Route path="/" element={<UserRoute><Navigate to="/projects/bakrajo-hills" replace /></UserRoute>} />
      <Route path="/projects" element={<Navigate to="/" replace />} />
      <Route path="/projects/:projectId" element={<UserRoute><ProjectDetailPage /></UserRoute>} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<Navigate to="/login" replace />} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/projects" element={<AdminRoute><AdminProjects /></AdminRoute>} />
      <Route path="/admin/units" element={<AdminRoute><AdminUnits /></AdminRoute>} />
      <Route path="/admin/units/:projectId" element={<AdminRoute><AdminUnits /></AdminRoute>} />
      <Route path="/admin/map-editor" element={<AdminRoute><AdminMapEditor /></AdminRoute>} />
      <Route path="/admin/map-editor/:projectId" element={<AdminRoute><AdminMapEditor /></AdminRoute>} />
      <Route path="/admin/sync" element={<AdminRoute><AdminSync /></AdminRoute>} />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <UserAuthProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </UserAuthProvider>
  );
}

export default App;
